//require('./bootstrap');
//require('bootstrap');

//window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    //window.Popper = require('popper.js').default;
    //window.$ = window.jQuery = require('jquery');
    L = require('leaflet');
    L.Icon.Default.imagePath = "/images/vendor/leaflet/dist/";

    require('leaflet-routing-machine');

    window.L.icons = {
        home :  {
            className: 'leaflet-marker-icon-custom',
            html: '<div> ' +
            '<img class="" src="https://maps.google.com/mapfiles/kml/pal3/icon56.png"/>' +
            '</div>',
            iconSize:     [40, 40], // size of the icon
            iconAnchor:   [15, 40], // point of the icon which will correspond to marker's location
        },
        green : {
            className: 'leaflet-marker-icon-custom',
            html: '<img class="" src="https://maps.google.com/mapfiles/ms/icons/green.png"/>' +
            '<span class=""></span>',
            iconSize:     [40, 40], // size of the icon
            iconAnchor:   [15, 40], // point of the icon which will correspond to marker's location
        }
    }

    weekSelectPlugin = require("flatpickr/dist/plugins/weekSelect/weekSelect.js");
    monthSelectPlugin = require("flatpickr/dist/plugins/monthSelect/index");

    require("flatpickr");
    require("flatpickr/dist/l10n/hu.js");

    //require('tooltip');
    //require('jquery-form');
    //require('./custom');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

//window.axios = require('axios');

//window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
